import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { CalendarRange } from "lucide-react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const monthLabel = (m) => (m ? `${MONTHS[Number(m.slice(5)) - 1]} ${m.slice(0, 4)}` : "");
export const shiftMonth = (m, n) => {
  const i = Number(m.slice(0, 4)) * 12 + Number(m.slice(5)) - 1 + n;
  return `${Math.floor(i / 12)}-${String((i % 12) + 1).padStart(2, "0")}`;
};

export const PRESETS = [
  { key: "this_month", label: "This month", range: (c) => [c, c] },
  { key: "last_month", label: "Last month", range: (c) => [shiftMonth(c, -1), shiftMonth(c, -1)] },
  { key: "last_3", label: "Last 3 months", range: (c) => [shiftMonth(c, -2), c] },
  { key: "ytd", label: "Year to date", range: (c) => [`${c.slice(0, 4)}-01`, c] },
  { key: "custom", label: "Custom range" },
];

const MonthSelect = ({ value, months, onChange, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-[130px] h-9" data-testid={testId}><SelectValue /></SelectTrigger>
    <SelectContent>{months.map((m) => <SelectItem key={m} value={m} data-testid={`${testId}-${m}`}>{monthLabel(m)}</SelectItem>)}</SelectContent>
  </Select>
);

export const SalesPeriodBar = ({ value, months, onChange }) => {
  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <Card className="border-slate-200" data-testid="vz-period-bar">
      <CardContent className="p-3 flex flex-wrap items-center gap-3">
        <span className="flex items-center gap-1.5 text-sm font-medium text-navy"><CalendarRange className="w-4 h-4 text-teal" /> Period</span>
        <Select value={value.preset} onValueChange={(preset) => set({ preset })}>
          <SelectTrigger className="w-[160px] h-9" data-testid="vz-period-preset"><SelectValue /></SelectTrigger>
          <SelectContent>{PRESETS.map((p) => <SelectItem key={p.key} value={p.key} data-testid={`vz-period-preset-${p.key}`}>{p.label}</SelectItem>)}</SelectContent>
        </Select>
        {value.preset === "custom" && (
          <div className="flex items-center gap-2 text-sm text-slate-500" data-testid="vz-period-custom">
            From <MonthSelect value={value.start} months={months} onChange={(start) => set({ start })} testId="vz-period-from" />
            to <MonthSelect value={value.end} months={months} onChange={(end) => set({ end })} testId="vz-period-to" />
          </div>
        )}
        <label className="flex items-center gap-2 text-sm text-slate-600 ml-auto cursor-pointer">
          <Switch checked={value.compare} onCheckedChange={(compare) => set({ compare })} data-testid="vz-period-compare" />
          Compare to previous period
        </label>
      </CardContent>
    </Card>
  );
};
